<template>
  <div class="updataPassword">
    <div class="head">修改密码</div>
    <el-form label-position="right" :rules="rules" label-width="140px" :model="contentObj">
      <el-form-item label="输入原密码" prop="oldPassWord">
        <el-input 
          type="password"
          placeholder="请输入原始密码"
          v-model="contentObj.oldPassWord"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="输入新密码" prop="newPassWord"
        ><el-input
          type="password"
          placeholder="请输入新密码"
          v-model="contentObj.newPassWord"
        ></el-input
      ></el-form-item>
      <el-form-item label="请再次输入新密码" prop="newPassWord2"
        ><el-input
          type="password"
          placeholder="请再次输入新密码"
          v-model="contentObj.newPassWord2"
        ></el-input
      ></el-form-item>
      
        <el-form-item>
        <div class="btnList">
            <button class="sucess">确认</button>
            <button class="del">取消</button>
        </div>
    </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
    data(){
        return{
            contentObj:{
                oldPassWord:'',
                newPassWord:'',
                newPassWord2:'',
            },
            rules:{
                oldPassWord:[ { required: true, message: '请输入原始密码', trigger: 'blur' },],
                newPassWord:[ { required: true, message: '请输入新密码', trigger: 'blur' },],
                newPassWord2:[ { required: true, message: '请再次输入新密码', trigger: 'blur' },],
            }
        }
    }
};
</script>

<style scoped>
.sucess{
    background-color: #0D53FF;
    color: white;
  
}
.del{
    background-color: #fff;
    color: #666666;
    
}
.btnList button{
    width: 80px;
    height: 32px;
       border: 1px solid #E9E9E9;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 4px;
}
::v-deep .el-input {
  width: 570px;
  height: 36px;
}::v-deep .el-textarea textarea {
  width: 570px;
  height: 100px;
}
::v-deep .el-textarea  {
  width: 570px;
  height: 100px;
}
.head {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 27px;
}
.updataPassword {
  margin-top: 24px;
  margin-left: 24px;
  font-family: Regular;
}
</style>